'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reselect = require('reselect');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _lodash = require('lodash');

var _elementRegistry = require('../../../../common/elements/elementRegistry');

var elementRegistry = _interopRequireWildcard(_elementRegistry);

var _selectedElementsSelector = require('../../../element/selection/selectedElementsSelector');

var _currentlyEditingSelector = require('../../../element/selection/currentlyEditingSelector');

var _elementHelper = require('../../../../common/elements/elementHelper');

var _SelectionTool = require('./SelectionTool');

var _SelectionTool2 = _interopRequireDefault(_SelectionTool);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Lib


// Registry


// Selectors


// Utils


// Components


var getToolModes = function getToolModes(selectedElements) {
    var toolTypes = Immutable.OrderedMap();

    var isMultiSelect = selectedElements.size > 1;
    var toolArrays = selectedElements.map(function (el) {
        return (
            // Don't load any tools for skeleton elements
            (0, _elementHelper.isSkeleton)(el) ? [] : elementRegistry.getElementTools(el.get('elementType'))
        );
    }).toJS();

    var commonTools = _lodash.intersection.apply(undefined, _toConsumableArray(toolArrays));
    commonTools.forEach(function (tool) {
        if (isMultiSelect && !tool.multiSelect) return;
        toolTypes = toolTypes.set(tool.id, tool);
    });

    return toolTypes.toArray();
};

var toolModeSelector = (0, _reselect.createSelector)(_selectedElementsSelector.getSelectedElements, _currentlyEditingSelector.getCurrentlyEditingEditorKey, function (selectedElements, editorKey) {
    return {
        selectedElements: selectedElements,
        editorKey: editorKey,
        toolModes: getToolModes(selectedElements)
    };
});

var SelectionToolList = function SelectionToolList(_ref) {
    var toolModes = _ref.toolModes,
        selectedElements = _ref.selectedElements,
        editorKey = _ref.editorKey,
        gridSize = _ref.gridSize;
    return _react2.default.createElement(
        'div',
        { className: 'ToolList SelectionToolList' },
        toolModes.map(function (tool, i) {
            return _react2.default.createElement(_SelectionTool2.default, { key: i,
                toolMode: tool,
                selectedElements: selectedElements,
                editorKey: editorKey,
                gridSize: gridSize });
        })
    );
};

SelectionToolList.propTypes = {
    toolModes: _propTypes2.default.array,
    selectedElements: _propTypes2.default.object,
    editorKey: _propTypes2.default.string,
    gridSize: _propTypes2.default.number.isRequired
};

exports.default = (0, _reactRedux.connect)(toolModeSelector, null)(SelectionToolList);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/SelectionToolList.js
// module id = 2224
// module chunks = 0